import { ErrorOutline } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const ChartFailMessage = () => {
  const { t } = useTranslation(['dashboard']);
  return (
    <Box
      sx={{
        mt: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '20rem',
        flexDirection: 'column',
        borderRadius: 1,
        border: (theme) => `1px dashed ${theme.palette.grey[400]}`,
      }}
    >
      <ErrorOutline sx={{ fontSize: '8rem', mb: 4, color: (theme) => theme.palette.grey[300] }} />
      <Typography variant='h5' sx={{ color: (theme) => theme.palette.grey[400] }}>
        {t('chartFailMessage')}
      </Typography>
    </Box>
  );
};
